// extracted by mini-css-extract-plugin
export default {"tableWrapper":"MerchantOverviewTable_tableWrapper__OT5+X"};